<template>
  <NInput ref="inputRef" class="c-input">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </NInput>
</template>

<script lang="ts">
export default {
  name: 'CInput',
}
export interface CInputProps extends /* @vue-ignore */ InputProps {}
</script>

<script setup lang="ts">
import { NInput, type InputProps } from 'naive-ui'
import { ref } from 'vue'

defineProps<CInputProps>()
defineSlots()

const inputRef = ref<InstanceType<typeof NInput> | null>(null)

defineExpose({
  focus: () => inputRef.value?.focus as void,
})
</script>
